import script from "./VehicleReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleReturn.vue?vue&type=script&setup=true&lang=js"

import "./VehicleReturn.vue?vue&type=style&index=0&id=06fb342c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fb342c"]])

export default __exports__